import React, { useEffect, useState } from 'react'
import logo from 'assets/icons/logo.png'
import menu from 'assets/icons/menu.svg'
import Navigation from 'components/Navigation'

function Header() {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true)
  const [showNavigation, setShowNavigation] = useState(false)
  const [lastScrollY, setLastScrollY] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY
      if (Math.abs(currentScrollY - lastScrollY) > 200) {
        setIsHeaderVisible(currentScrollY < lastScrollY)
        setLastScrollY(currentScrollY)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [lastScrollY])

  const handleClick = () => setShowNavigation(!showNavigation)

  // 🔽 Função para rolar suavemente até a seção
  const scrollToSection = (id) => {
    const section = document.querySelector(id)
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <>
      <header
        className={`fixed top-0 z-30 flex w-full flex-col items-center justify-center bg-blue text-white shadow-lg transition-all duration-500 ${isHeaderVisible ? 'translate-y-0' : '-translate-y-full'}`}
      >
        <nav className='flex w-11/12 items-center justify-between p-2'>
          <a href='https://lidercredsolucoes.com.br'>
            <picture>
              <img src={logo} alt='Líder Cred - Soluções Financeiras' className='w-40' />
            </picture>
          </a>

          <ul className='hidden items-center gap-8 md:flex'>
            <li>
              <button
                onClick={() => scrollToSection('#nossos-servicos')}
                className='text-lg uppercase transition-colors duration-200 hover:text-yellow'
              >
                Nossos Serviços
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('#quem-somos')}
                className='text-lg uppercase transition-colors duration-200 hover:text-yellow'
              >
                Quem Somos
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection('#contatos')}
                className='text-lg uppercase transition-colors duration-200 hover:text-yellow'
              >
                Contatos
              </button>
            </li>
          </ul>

          <button className='md:hidden' onClick={handleClick}>
            <img src={menu} alt='Ícone de Menu Hamburger' className='w-8' />
          </button>
        </nav>
      </header>

      <Navigation isOpen={showNavigation} onClose={() => setShowNavigation(false)} />
    </>
  )
}

export default Header
